import styled from "styled-components";

export const Container = styled.form<{
  $hasAreaDriverAssigned: boolean;
  $isMapArea?: boolean;
}>`
  background: ${({ theme }) => theme.palette.background.paper};
  width: 502px;
  box-sizing: border-box;
  border: ${({ theme, $hasAreaDriverAssigned, $isMapArea }) =>
    $isMapArea || $hasAreaDriverAssigned
      ? "none"
      : `4px solid ${theme.palette.primary.main}`};

  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  padding: 25px;
  margin-top: 25px;
`;

export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 25px;
`;
